import axios from '@axios'
import store from '..'

const route = 'configuration/access_control'

export default {
  namespaced: true,
  state: {
    roles: [],
  },
  getters: {},
  mutations: {},
  actions: {
    index(context, payload) {
      return axios.post(route, payload)
    },
    store(context, payload) {
      return axios.post(`${route}/store`, payload)
    },
    update(context, payload) {
      return axios.put(`${route}/${payload.id}`, payload)
    },
    destroy(context, id) {
      return axios.delete(`${route}/${id}`)
    },
  },
}
